export { API_BASE_URL, ASSET_URL, IMAGE_URL } from './envConfig';

export const ASSEET_LISTING_LIMIT = 20; // Number of items per page (backend hard cap is 20)
export const ROLE_ADMIN = 1;
export const ROLE_USER =3;
export const EMAIL_ADDDRESS_SUFFIX = '@yopmail.com';